import {
  findMatchingVariant 
} from "@/util/findMatchingProductVariant"
import {
  isProductConfigurable 
} from "@/util/isProductConfigurable"
import {
  useMemo 
} from "react"

const OUT_OF_STOCK_CODE = "OUT_OF_STOCK"
const IN_STOCK_CODE = "IN_STOCK"

const getIsOutOfStock = (product, optionCodes, optionSelections) => {
  const {
    stock_status, variants 
  } = product

  const isConfigurable = isProductConfigurable(product)

  const optionSelectionsArrray = Array.from(optionSelections.values())
  const optionsSelectedLength = optionSelectionsArrray.filter((value) => {
    return !!value
  }).length

  let optionsSelected = false

  if (optionsSelectedLength >= optionSelectionsArrray.length) {
    optionsSelected = true
  }

  if (isConfigurable && optionsSelected) {
    const item = findMatchingVariant({
      optionCodes,
      optionSelections,
      variants,
    })

    const {
      product 
    } = item || {}

    const {
      presale_product 
    } = product || {}

    const {
      status: isPreOrder 
    } = presale_product || {}

    if (isPreOrder) {
      return false
    }

    const stockStatus = item?.product?.stock_status

    return stockStatus === OUT_OF_STOCK_CODE || !stockStatus
  }

  return stock_status === OUT_OF_STOCK_CODE
}

export const useGetIsOutOfStock = ({
  product,
  optionCodes,
  optionSelections,
}: {
    product: any
    optionCodes: any
    optionSelections: any
}) => {
  const isOutOfStock = useMemo(
    () => getIsOutOfStock(product, optionCodes, optionSelections),
    [product, optionCodes, optionSelections]
  )

  return {
    isOutOfStock,
  }
}
